import axios from 'axios'

/**
 * 学生评价老师 · 接口封装
 *
 * 后端：dt6 的 evaluate 模块（接口已放开 CORS，前端可直接跨域访问）
 *
 * 联调地址切换（只改 EVAL_API 一处）：
 *   本地开发：'http://www.dt6666.com/dt6/public/index.php/evaluate'
 *   线上部署：'/api/evaluate'（走 nginx 的 /api 代理，见 vue.config.js）
 */
export const EVAL_API = 'https://www.ysdeyu.cn/dt6/public/index.php/evaluate' // https://www.ysdeyu.cn

const service = axios.create({
  baseURL: EVAL_API,
  timeout: 1000 * 30
})

//请求拦截器：带上 token
service.interceptors.request.use((config) => {
  const admin = config.url && config.url.indexOf('/admin/') === 0
  config.headers['token'] = localStorage.getItem(admin ? 'eval_admin_token' : 'eval_token') || ''
  return config
}, (error) => {
  return Promise.reject(error)
})

//响应拦截器：直接返回后端的 {code,msg,data}
service.interceptors.response.use((response) => {
  return response.data
}, (error) => {
  return Promise.reject(error)
})

/* ---------------- 学生端 ---------------- */

// 登录（账号=身份证后6位，默认密码同账号）
export const evalLogin = (data) => service.post('/api/login', data)

// 首页数据（学生信息、批次、指标、任课教师、已提交情况）
export const evalIndex = () => service.post('/api/index')

// 修改密码
export const evalChangePwd = (data) => service.post('/api/change_password', data)

// 一次性提交全部教师评价与提问次数
export const evalSubmit = (data) => service.post('/api/submit', data)

// 提交教学常规评价（每月一次）
export const evalSubmitEval = (data) => service.post('/api/submit_eval', data)

// 上报提问次数（每周一次）
export const evalSubmitAsk = (data) => service.post('/api/submit_ask', data)

// 上报导师谈话记录（每周一次，独立提交）
export const evalSubmitTalk = (data) => service.post('/api/submit_talk', data)

/* ---------------- 教务处统计端 ---------------- */

// 登录（think_admin 账号）
export const evalAdminLogin = (data) => service.post('/admin/login', data)

// 总览 + 教师排行 + 班级进度
export const evalAdminStats = (data) => service.post('/admin/stats', data)

// 单个教师明细
export const evalAdminDetail = (data) => service.post('/admin/teacher_detail', data)

// 导出 CSV（token 放 url 上，方便 window.open）
// type: eval=教学评价表 | ask=提问次数表 | talk=导师谈话表
export const evalAdminExportUrl = (type = 'eval', batchId = '') => {
  const token = encodeURIComponent(localStorage.getItem('eval_admin_token') || '')
  return EVAL_API + '/admin/export?type=' + type + '&token=' + token
    + (batchId ? '&batch_id=' + batchId : '')
}

// 批次列表
export const evalAdminBatchList = () => service.post('/admin/batch_list')

// 开启新批次（自动关闭旧批次）
export const evalAdminBatchSave = (data) => service.post('/admin/batch_save', data)

// 把历史批次设为当前批次
export const evalAdminBatchActivate = (data) => service.post('/admin/batch_activate', data)

// 学生账号搜索（密码重置用）
export const evalAdminStudentList = (data) => service.post('/admin/student_list', data)

// 重置单个学生密码
export const evalAdminStudentReset = (data) => service.post('/admin/student_reset', data)

// 一键重置全部学生密码
export const evalAdminStudentResetAll = () => service.post('/admin/student_reset_all')

// 读取提交时间窗口配置
export const evalAdminConfigGet = () => service.post('/admin/config_get')

// 保存提交时间窗口配置
export const evalAdminConfigSave = (data) => service.post('/admin/config_save', data)
